import axiosInstance from "../axios";

export const getStoreCoupons = () => axiosInstance.get("/store/coupons");

export const createStoreCoupon = (coupon) =>
  axiosInstance.post("/store/coupons", { coupon });

export const updateStoreCoupon = (couponId, coupon) =>
  axiosInstance.patch(`/store/coupons/${couponId}`, { coupon });

export const deleteStoreCoupon = (couponId) =>
  axiosInstance.delete(`/store/coupons/${couponId}`);

export const searchStoreCoupons = (code, projectId) =>
  axiosInstance.get("/store/coupons/search", {
    params: { code, project_id: projectId },
  });

export const applyStoreProjectCoupon = (projectId, payload) =>
  axiosInstance.post(`/store/projects/${projectId}/coupons`, payload);

export const removeStoreProjectCoupon = (projectId, couponId) =>
  axiosInstance.delete(`/store/projects/${projectId}/coupons/${couponId}`);
